import React from 'react'
import matrixSpinner from './matrix-spinner.svg'

interface Props {
    fitContainer?: boolean
}

const FULL_SCREEN_SIZE = 160
const INLINE_SIZE = 80

const Loader: React.FunctionComponent<Props> = ({ fitContainer }) => {
    const size = fitContainer ? INLINE_SIZE : FULL_SCREEN_SIZE

    return (
        <div
            className={`w-100 h-100 d-flex justify-content-center align-items-center ${fitContainer ? 'full-height' : ''}`}
            role="status"
            aria-live="polite"
            aria-label="loader"
        >
            <img
                src={matrixSpinner}
                alt="Loading..."
                width={size}
                height={size}
                style={{ width: size, height: size, flexShrink: 0 }}
            />
        </div>
    )
}

export default Loader
